export default __webpack_public_path__ + "static/media/sconeClassDetail.2b8e1c50.jpg";